export var API_END_POINT_Dev = "https://api.edeecircle.com/";
export var API_END_POINT_Live = "https://api.edeecircle.com/";
// export var API_END_POINT_Dev = "http://52.22.219.46:3000/";
// export var API_END_POINT_Live = "http://52.22.219.46:3000/";
